const $window = $(window);

export default function(options) {

	var
	settings = $.extend({
		id: 'id',
		key: '6038e85e-3df6-409a-a309-241bcb6bcd99'
	}, options);

	const render = () => {
		this.each(function() {
			var
			count = 0,
			max = 6,
			_this = this,
			$this = $(_this);

			$.ajax({
				url: `https://api.curator.io/v1/feeds/${settings.id}/posts`,
				data: {
					api_key: settings.key
				},
				success: function(json) {

					json.posts.forEach(function(post) {

						if(count<max&&post.has_image) {
							$this.append(`<a target="_blank" href="${post.url}" class="ig-footer-block has-igs-overlay"><img src="${post.image}"></a>`);
							count ++;
						};

					});

					new FTScroller(_this, {
						scrollingY: false,
						snapping: false,
						scrollbars: false,
						bouncing: false,
						updateOnWindowResize: true,
						disabledInputMethods: { mouse: false, touch: false, scroll: true, pointer: false, focus: false }
					});

				}
			});
		});
	}

	this.lazyLoadOnScroll({
		handler : function() {
			render();
		},
		threshold : -1000 - $window.height()
	});

};
